import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import ActionLink from '../ActionLink';

/**
 * @deprecated Use { MenuItem } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/menu--docs
 */

const CardMenuItem = ({
  children,
  onClick,
  href,
  target,
  className,
  ...props
}) => {
  const classes = cx('dropdown-menu__link', className);

  if (!href && !onClick) {
    return null;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    onClick(e);
  };

  if (href) {
    return (
      <a className={classes} href={href} target={target} {...props}>
        {children}
      </a>
    );
  }

  return (
    <ActionLink className={classes} {...props} onClick={handleClick}>
      {children}
    </ActionLink>
  );
};

CardMenuItem.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
};

export default CardMenuItem;
